export default __webpack_public_path__ + "static/media/04 - Default.aspx (1).661c1180.png";